import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'

class CentrePattern extends Component {
  state = {
    InlineSvg: null,
  }

  componentDidMount() {
    import(
      /* webpackChunkName: "[request]" */
      `../../assets/images/centre-patterns/${this.props.slug}.inline.svg`
    )
      .then(module => {
        this.setState({ InlineSvg: module.default })
        return module
      })
      .catch(err => {
        if (__DEV__) {
          throw err
        }
      })
  }

  render() {
    const { InlineSvg } = this.state
    return (
      <div className={styles.CentrePattern}>{InlineSvg && <InlineSvg />}</div>
    )
  }
}

CentrePattern.propTypes = {
  slug: PropTypes.string,
}

export default CentrePattern
